import Button from 'portal-modules/common/components/Button'
import { CardGrid } from '@entrata/portals-common/lib/components'
import { underlineFocus } from 'portal-modules/common/components/focus-styles'

import styled from '@emotion/styled'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

export const StyledCardName = styled('div')`
  display: flex;
  padding: 8px 0;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
`

export const StyledCardImage = styled('img')`
  margin-right: auto;
  width: 100%;
  max-width: 60px;
  height: auto;
`

export const StyledCardNumber = styled('div')`
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};

  @media (max-width: 767px) {
    font-size: 14px;
    display: block;
  }
`

export const StyledSepaCardNumber = styled(StyledCardNumber)`
  font-size: 12px;
`

export const StyledNumber = styled('span')`
  font-weight: bold;

  &:first-child {
    margin-left: 0;
  }

  @media (max-width: 767px) {
    margin-left: 16px;
  }
`

export const StyledCardDetails = styled('div')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
  font-size: 11px;
  padding-top: 8px;
  display: flex;
`

export const StyledSepaDiv = styled('div')`
  border-bottom: 2px solid ${({ theme }) => theme.gray.light};
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 16px;
  h4 {
    font-size: 14px;
    font-weight: bold;
    margin: 0 0 8px;
  }
`

export const StyledSepaHeader = styled('span')`
  font-weight: bold;
`

export const StyledSepaContent = styled('div')`
  width: 100%;
  margin-bottom: 32px;
`

export const StyledSepaSection = styled('section')`
  display: flex;
  flex-direction: ${({ idMargin }) => (idMargin ? 'row-reverse' : 'initial')};
  justify-content: space-between;
  margin-top: ${({ noMargin }) => (noMargin ? '0' : '16px')};
  margin-bottom: ${({ noMargin }) => (noMargin ? '0' : '16px')};
`

export const StyledSepaLabel = styled('span')`
  font-size: 13px;
  margin-left: ${({ addressMargin, labelMargin }) =>
    addressMargin ? '75px' : labelMargin ? 'auto' : '0'};
  text-align: ${({ addressAlign }) => (addressAlign ? 'right' : 'auto')};
`

export const StyledSepaValue = styled('span')`
  font-size: 13px;
  margin-left: ${({ addressMargin, labelMargin }) =>
    addressMargin ? '75px' : labelMargin ? 'auto' : '0'};
  text-align: ${({ addressAlign }) => (addressAlign ? 'right' : 'auto')};
`

export const StyledMandateButton = styled('span')`
  display: flex;
  color: ${({ theme }) => theme.blue.base};
  cursor: pointer;
`

export const StyledCardHolderName = styled('span')`
  margin-right: auto;
`

export const StyledExpiredDate = styled('span')`
  margin-left: auto;
`

export const StyledCardLabel = styled('span')`
  margin-left: auto;
  font-size: 10px;
  color: ${({ theme }) => theme.success.base};
`

export const StyledPadCardFooter = styled('div')`
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  font-weight: 300;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.dark};
`
export const StyledPadCardDeailsDiv = styled('div')`
  display: flex;
  flex-direction: column;
  font-size: 15px;

  & > span:first-child {
    font-size: 8px;
  }
`

export const StyledCard = styled('div')`
  border: 1px solid ${({ theme }) => theme.secondary.base};
  list-style-type: none;
  padding: 64px 32px;
`

// Only one card need to be shown always (styled as card in mobile device but as a row in tablet and desktop devices)
export const StyledResponsiveGrid = styled(CardGrid)`
  margin: 0;
  box-shadow: ${({ theme }) => theme.mode.card_shadow};
  @media screen and (min-width: 768px) {
    margin-top: 16px;
  }

  @media screen and (min-width: 1024px) {
    margin: ${({ noMargin }) => (noMargin ? '0' : '16px 40px 0')};
  }
`

export const StyledCardLI = styled('li')`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.gray.light};
  box-shadow: ${({ theme }) => theme.mode.card_shadow};
  color: ${({ theme }) => theme.text.dark};
  font-size: 13px;
  margin: 16px 16px 0 16px;
  overflow: hidden;
  padding: 16px;
  width: 100%;

  @media screen and (min-width: 768px) {
    align-items: center;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.gray.light};
    box-shadow: none;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    margin: 0;
    padding: 24px 40px;
    width: 100%;

    &:first-child {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1024px) {
    padding: 24px 0;
  }
`

export const StyledCardTitle = styled('h4')`
  color: ${({ theme }) => theme.gray.dark};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (min-width: 1024px) {
    font-size: 16px;
  }
`

export const StyledWrapperDiv = styled('div')`
  flex-grow: 1;
`

export const StyledTitleWrapper = styled('div')`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  @media screen and (min-width: 768px) {
    align-items: center;
    margin-bottom: 0;
  }
`

export const StyledWrapperSpan = styled('span')`
  align-items: center;
  display: flex;
  margin-left: 16px;
`

export const StyledActionButton = styled(Button)`
  margin-top: 24px;

  @media screen and (min-width: 768px) {
    margin: 0;
  }
`

export const StyledIconButton = styled('button')`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.blue.system_blue};
  height: 24px;
  padding: 0;
  width: 24px;

  ${underlineFocus};

  &:not(:last-child) {
    margin-right: 8px;
    margin-left: 8px;
  }
`

export const StyledTypeSpan = styled('span')`
  display: block;
  font-size: 15px;
  font-weight: 500;
`

export const StyledSpan = styled('span')`
  font-style: italic;
  font-size: 12px;

  @media screen and (min-width: 768px) {
    font-style: normal;
    font-size: 15px;
  }

  @media screen and (min-width: 1024px) {
    font-size: 13px;
  }
`

export const StyledDateTime = styled('time')`
  display: block;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  margin-top: 24px;

  @media screen and (min-width: 768px) {
    display: inline;
  }
`

export const StyledRoutingNumber = styled('span')`
  font-size: 10px;
`

export const StyledSepaSpan = styled('span')`
  margin-right: 8px;
  margin-left: 8px;
`

export const StyledCardWithoutLink = styled('a')`
  width: 114px;

  border: 1px solid ${({ theme }) => theme.gray.light};
  border-radius: 24px;
  color: ${({ theme }) => theme.secondary.base};
  cursor: pointer;
  display: flex;
  align-items: start;
  flex-direction: column;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  transition: all 250ms ease-out;
  position: relative;

  ${underlineFocus}
  @media screen and (min-width: 500px) {
    align-items: center;
  }
  padding: 8px;
`
export const StyledNew = styled.span`
  height: 16px;
  background: ${({ theme }) => theme.blue.blue1};
  border-radius: 100px;
  font-weight: 700;
  font-size: 8px;
  line-height: 8px;
  padding: 4px 8px;
  position: absolute;
  right: 16px;
  color: ${({ theme }) => theme.blue.system_blue};
`
